import type { SelectProps } from '@brighterly/lib-lumee-ui'
import type { SelectMode } from '@brighterly/lib-core-types/ui/selects/types'

export const toSelectStatus = (mode: SelectMode): SelectProps['status'] => (mode === 'normal' ? undefined : mode)

// The DS types Select's `update:modelValue` as `TValue | undefined`, but the select only ever emits a chosen item's value.
export const whenSelected = <TValue>(handler: (value: TValue) => void) => (value: TValue | undefined): void => {
  if (value !== undefined) handler(value)
}
